module.exports = __webpack_public_path__ + "static/media/Banco_Atlantida.295799be.ico";